import React from 'react'
import { Outlet } from 'react-router-dom'
const Mail = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default Mail
